import { render, staticRenderFns } from "./СonfirmationСode.vue?vue&type=template&id=833ba7a6&scoped=true&"
import script from "./СonfirmationСode.vue?vue&type=script&lang=js&"
export * from "./СonfirmationСode.vue?vue&type=script&lang=js&"
import style0 from "./СonfirmationСode.vue?vue&type=style&index=0&id=833ba7a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833ba7a6",
  null
  
)

export default component.exports